import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { Directions } from "common/components/drop-menu/types";
import { ProjectSelectorEl } from "common/widgets/project-selector";
import { CoreBanner } from "../template";
import { DropdownType } from "../types";
function Dropdown(type, positionParent, openMenuCallback, menuItemSelectedCallback) {
  switch (type) {
    case DropdownType.ProjectSelector:
      return /* @__PURE__ */ jsx(ProjectSelectorEl, { params: {
        direction: Directions.Down,
        offset: 2,
        positionParent,
        searchPlaceholder: "Search",
        submitCopy: "Create New Project"
      }, on: {
        menuchange: (ev) => openMenuCallback(ev.detail.state === "open"),
        select: (ev) => menuItemSelectedCallback(DropdownType.ProjectSelector, ev)
      } });
    default:
      return null;
  }
}
export function template() {
  const hasDropdown = this.attr("dropdown") && DropdownType[DropdownType[this.attr("dropdown").dropdownType]] !== void 0;
  const dropdownNode = hasDropdown ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, { sel: ".cta-button", attrs: {
    pressed: this.state.isDropdownOpen,
    theme: this.attr("dropdown").theme
  }, on: {
    click: () => this.helpers.setDropdownOpen(true)
  } }, this.attr("dropdown").label), this.state.isDropdownOpen && Dropdown(this.attr("dropdown").dropdownType, this.el.querySelector(".cta-button"), this.helpers.setDropdownOpen, this.helpers.handleMenuItemSelected)) : null;
  return CoreBanner(this, dropdownNode);
}
